function setDebugModeEnabled(debugModeEnabled) {
  return {
    type: 'SET_DEBUG_MODE_ENABLED',
    debugModeEnabled,
  };
}

module.exports = {
  setDebugModeEnabled,
};
